import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SeoService } from '../../seo/seo.service';

@Component({
  standalone: true,
  selector: 'app-blog-impresa-pulizie',
  imports: [CommonModule, RouterModule],
  templateUrl: './cosa-valutare-impresa-di-pulizie.html',
  styleUrls: ['./cosa-valutare-impresa-di-pulizie.scss'],
})
export class BlogImpresaPulizieComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Cosa valutare quando scegli un’impresa di pulizie | SAMI Pulizie',
      description:
        'Guida pratica su cosa valutare quando scegli un’impresa di pulizie a Pescara: esperienza, servizi, prezzi, materiali e certificazioni.',
      keywords:
        'impresa di pulizie Pescara, scegliere impresa di pulizie, servizi di pulizia professionali, sanificazioni, SAMI Pulizie',
      canonicalUrl: '/blog/cosa-valutare-impresa-di-pulizie',

      ogTitle: 'Cosa valutare quando scegli un’impresa di pulizie',
      ogDescription:
        'Esperienza, servizi, prezzi e certificazioni: guida per scegliere la giusta impresa di pulizie a Pescara.',
      ogImage: '/assets/logo.png',
      ogType: 'article',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        headline: 'Cosa valutare quando scegli un’impresa di pulizie',
        description:
          'Guida completa su come scegliere un’impresa di pulizie affidabile: referenze, servizi, trasparenza nei prezzi e certificazioni.',
        datePublished: '2025-02-20',
        dateModified: '2025-02-20',
        author: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
        },
        publisher: {
          '@type': 'Organization',
          name: 'SAMI Pulizie',
          logo: {
            '@type': 'ImageObject',
            url: 'https://samipulizie.it/assets/logo.png',
          },
        },
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': 'https://samipulizie.it/blog/cosa-valutare-impresa-di-pulizie',
        },
      },
    });
  }
}
